import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import * as signalR from "@microsoft/signalr"
import {HubConnection} from "@microsoft/signalr";

export type SocketContextType = {
    socket: HubConnection | null,
}

const SocketContext = createContext<SocketContextType>({} as SocketContextType);

export const useSocketContext = () => {
    return useContext(SocketContext);
}

export default function SocketProvider(props: { children: ReactNode }) {
    const [socket, setSocket] = useState<HubConnection | null>(null);

    useEffect(() => {
        startConnection();
    }, []);

    useEffect(() => {
        return () => {
            if (socket) {
                socket?.stop().then();
            }
        }
    }, [socket])

    async function startConnection() {
        let connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_CHAT_BOT_SOCKET_URL, {
                accessTokenFactory(): string | Promise<string> {
                    return localStorage.getItem("access_token");
                }
            })
            .withAutomaticReconnect()
            .build();

        await connection.start();

        setSocket(connection);
    }

    return (
        <SocketContext.Provider value={{socket: socket}}>
            {props.children}
        </SocketContext.Provider>
    )
};
